"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.defaultInitialConfig = void 0;

var _react = require("react");

var defaultInitialConfig = {
  display: {
    position: 'right'
  }
};
/**
 * Setup Beacon params.
 * @param {IBeaconConfig} initialConfig
 * @return {(config: IBeaconConfig) => void}
 */

exports.defaultInitialConfig = defaultInitialConfig;

var useSetBeaconConfig = function useSetBeaconConfig() {
  var initialConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultInitialConfig;
  (0, _react.useEffect)(function () {
    if (window.Beacon) {
      window.Beacon('config', initialConfig);
    }
  }, [initialConfig]);
  return (0, _react.useCallback)(function (config) {
    if (window.Beacon) {
      window.Beacon('config', config);
    }
  }, []);
};

var _default = useSetBeaconConfig;
exports["default"] = _default;